/**
 * Maps a Community.js normalized forum row (`normalizeForumRowToThread`) into the post object shape
 * consumed by `FeedPostCard` and `clubFeedPostUtils` (`titleFromPost`, `getImageAttachmentsFromPost`, etc.).
 *
 * @param {object} row
 * @param {boolean} [likedByViewer]
 */
export function forumFeedRowToFeedPostCard(row, likedByViewer = false) {
  if (!row || typeof row !== "object") return row;

  const title = String(row.title || "").trim();
  const body = String(row.body || "").trim();
  const content = body ? `${title}\n${body}` : title;

  const clubSlugStr =
    row.club_slug != null && String(row.club_slug).trim() !== ""
      ? String(row.club_slug).trim()
      : row.clubSlug != null && String(row.clubSlug).trim() !== ""
        ? String(row.clubSlug).trim()
        : "";
  const clubNameStr =
    row.club_name != null && String(row.club_name).trim() !== "" ? String(row.club_name).trim() : "";
  const clubAvatarStr =
    row.club_avatar_image_url != null && String(row.club_avatar_image_url).trim() !== ""
      ? String(row.club_avatar_image_url).trim()
      : "";

  const rawId = row.id;
  const id = rawId != null && String(rawId).trim() !== "" ? rawId : null;

  /** Full list from `normalizeForumRowToThread` when API returns `forum_post_attachments` JSON. */
  let attachments = [];
  if (Array.isArray(row.attachments) && row.attachments.length > 0) {
    attachments = row.attachments
      .filter(
        (a) =>
          a &&
          String(a.kind || "").toLowerCase() === "image" &&
          String(a.url || "").trim()
      )
      .map((a, idx) => ({
        kind: "image",
        url: String(a.url).trim(),
        sort_order: Number(a.sort_order ?? a.sortOrder) || idx,
        ...(a.id != null && Number.isFinite(Number(a.id)) ? { id: Number(a.id) } : {}),
      }));
  }

  const att = row.attachment;
  if (attachments.length === 0 && att && typeof att === "object") {
    const t = String(att.type || "").toLowerCase();
    const d = att.data && typeof att.data === "object" ? att.data : {};
    if (t === "image") {
      const u = String(d.url || d.preview || "").trim();
      if (u) attachments.push({ kind: "image", url: u, sort_order: 0 });
    } else if (t === "anime") {
      const u = String(d.image_url || "").trim();
      if (u) attachments.push({ kind: "image", url: u, sort_order: 0 });
    }
  }

  let image_url = null;
  let artwork_id = null;
  let artwork_image_url = null;
  let artwork_title = null;
  if (att && typeof att === "object") {
    const t = String(att.type || "").toLowerCase();
    const d = att.data && typeof att.data === "object" ? att.data : {};
    if (t === "artwork") {
      artwork_id = d.id != null ? d.id : null;
      artwork_image_url = d.image_url || null;
      artwork_title = d.title || null;
    }
  }

  return {
    id,
    user_id: row.authorId,
    username: row.author || "Guest",
    profile_picture: row.avatar,
    created_at: row.createdAt,
    content: String(content || "").trim() || "",
    like_count: Number(row.likes) || 0,
    comment_count: Number(row.replies) || 0,
    liked_by_viewer: Boolean(likedByViewer),
    attachments,
    image_url,
    artwork_id,
    artwork_image_url,
    artwork_title,
    ...(clubSlugStr
      ? {
          feed_club_slug: clubSlugStr,
          ...(clubNameStr ? { feed_club_name: clubNameStr } : {}),
          ...(clubAvatarStr ? { feed_club_avatar_url: clubAvatarStr } : {}),
        }
      : {}),
  };
}
